// extracted by css-extract-rspack-plugin
export default {"cls1":"PremiumBadge-cls1_mJL","cls2":"PremiumBadge-cls2_a2r PremiumBadge-cls1_mJL"};